import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// Load saved language or default
const stored = (typeof window !== "undefined" && localStorage.getItem("lang")) || undefined;
const initialLng = (stored as "ar" | "en") || "ar";

// Minimal resources demo – replace with your real dictionaries
const resources = {
  en: { translation: { "app.title": "Quran" } },
  ar: { translation: { "app.title": "القرآن" } },
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: initialLng,
    fallbackLng: "en",
    interpolation: { escapeValue: false },
  });

// Set initial dir on first load
if (typeof document !== "undefined") {
  const dir = initialLng === "ar" ? "rtl" : "ltr";
  document.documentElement.setAttribute("dir", dir);
}

export default i18n;
